import { createReducer } from "reduxsauce";
import Types from "./types";

export const INITIAL_STATE = {
    "successUrl": "",
    "cancelUrl": "",
    "failureUrl": "",
    "sessionData": ""
};

export const setPaymentConfiguration = (state = INITIAL_STATE, {data}) => {
    return { ...state, ...data};
};

export const sessionInit = (state = INITIAL_STATE, { data }) => {
    return {
        ...state,
        sessionData: data
    };
};

export const HANDLERS = {
    [Types.SET_PAYMENT_CONFIGURATION]: setPaymentConfiguration,
    [Types.SESSION_INIT]: sessionInit
};

export default createReducer(INITIAL_STATE, HANDLERS);
